import * as $ from 'jquery';
import * as Cookies from 'js-cookie';
import axios from "axios";
import {config} from "./config";
import Spinner from "./spinner";
import {confirmModal} from "./confirmModal";

let body = $("body");
let modal = $(".modal");

// Sidebar
$("#toggle_sidebar").click(function () {
    body.toggleClass('sidebar-collapsed');
    let currentState = body.hasClass('sidebar-collapsed');

    $('ul.sidebar__list').css('top', 0);

    Cookies.set('sidebar-collapsed', currentState);
})

$("a.parent")
    .click(function (e) {
        e.preventDefault();

        $(this).parent().next("ul.list__children").toggleClass('collapsed');
    })
    .hover(function () {
        if ($('body').hasClass('sidebar-collapsed')) {
            $(this).next("ul.list__children--dropdown").show();
        }
    }, function () {
        $(this).next("ul.list__children--dropdown").hide();
    })

$("ul.list__children--dropdown").hover(function () {
    if ($('body').hasClass('sidebar-collapsed')) {
        $(this).show();
    }
}, function () {
    $(this).hide();
})
.on('touchend', function() {
    if ($('body').hasClass('sidebar-collapsed')) {
        $(this).show();
    }
})

$(".sidebar__list > .list__element.active").each(function () {
    $(this).next("ul.list__children").removeClass('collapsed');
})

const hideSidebar = () => {
    body.addClass('sidebar-collapsed');
    Cookies.set('sidebar-collapsed', true);
}

if($(window).width() <= 991.98) {
    hideSidebar()
}

$(window).on('resize', function(e) {
    if(e.target.innerWidth <= 991.98) {
        hideSidebar();
    }
})

// Open saved tabs
export const changeNavTab = (nav, tab) => {
    let tabElement = $(nav).find(`#${tab}`)[0];
    let bsTab = new bootstrap.Tab(tabElement);

    if(bsTab && Object.keys(bsTab).length !== 0) {
        bsTab.show();
    }
}

let tabs = JSON.parse(Cookies.get(`nav-tabs`) || '{}');
if(typeof route != 'undefined' && tabs[route]) {
    for(let tab in tabs[route]) {
        if(!tabs[route].hasOwnProperty(tab)) {
            continue;
        }

        let nav = $(`.nav[id="${tab}"]`);
        if(nav.length === 0) continue;

        changeNavTab(nav, tabs[route][tab]);
    }
}

// Content height
$('body').css('display', 'flex');
// $(".dashboard section.content").css({minHeight: `${(window.innerHeight - $(".dashboard header").outerHeight() - $(".dashboard footer").outerHeight())}px`});

// Open modal with data-open="true" attribute
$(".modal[data-open='true']").each(function () {
    let modalInstance = new bootstrap.Modal(document.getElementById($(this).attr('id')));
    modalInstance.show();
})

// Reload, redirect
export const reload = () => {
    window.location.reload();
}

export const redirect = (path) => {
    window.location = url(path);
}

export const url = (path = "") => {
    return `${config('app.base_path')}/${path}`;
}

export const getPath = () => {
    let base_path = config('app.base_path');
    if(base_path === '' || base_path === '/') {
        return window.location.pathname;
    }

    return window.location.pathname.split(base_path).slice(1).join(base_path);
}

/**
 * Determine if current path matches pattern
 * @param {string|array<string>} patterns
 * @returns {boolean}
 */
export const pathIs = (patterns) => {
    if(typeof patterns != 'object' && patterns != null) {
        patterns = [patterns];
    }

    let url_string = getPath();

    if(url_string.slice(-1) === '/') {
        url_string = url_string.substr(0, url_string.length - 1);
    }

    for(let pattern of patterns) {

        if(url_string === pattern) {
            return true;
        }

        if(url_string === pattern + "#") {
            return true;
        }

        pattern = pattern.split('*').join('.*');
        pattern = new RegExp(`^${pattern}$`);

        if(pattern.test(url_string)) {
            return true;
        }
    }

    return false;
}

// Toasts
$(".toast").each(function () {
    let toast = new bootstrap.Toast($(this)[0]);
    toast.show();
})

// Lazy load select form values
modal.each(function() {
    let response;

    $(this)[0].addEventListener('show.bs.modal', async () => {
        let lazyLoadUrls = $(this).find('[data-lazy_load]');
        for(let element of lazyLoadUrls) {
            if($(element).is('select')) {
                let value = $(element).data('selected');

                if($(element).find('option').length === 0) {
                    let spinner = new Spinner();
                    response = await axios.get($(element).data('lazy_load'));

                    for(let option of response.data.data) {
                        let selected = parseInt(value) === parseInt(option.id);

                        $(element).append(`<option ${selected && 'selected'} value="${option.id}">${option.name}</option>`);
                    }

                    spinner.destroy();
                }
            }
        }
    })
})

// Remember nav tabs
$(".nav[role='tablist'] .nav-item .nav-link").click(function() {
    let navId = $(this).closest('.nav').attr('id');

    if(typeof navId == 'undefined' || navId === 'undefined') {
        return;
    }

    let data = JSON.parse(Cookies.get(`nav-tabs`) || '{}');

    if(!data[route]) {
        data = {
            ...data,
            [route]: {}
        }
    }

    if(!data[route][navId]) {
        data[route] = {
            ...data[route],
            [navId]: $(this).attr('id')
        }
    } else {
        data[route][navId] = $(this).attr('id')
    }

    Cookies.set(`nav-tabs`, JSON.stringify(data));
})

// Auto download file
$('a.auto-download[download]').each(function() {
    this.click();
})

// Form confirms
body.on('click', 'form[data-confirm]', async function(e) {
    e.preventDefault();

    let submitButton = $(this).find('button');
    if(submitButton.attr('disabled') === 'disabled') {
        return;
    }

    let color = $(this).data('confirm_color') || 'danger';

    let confirm = await confirmModal($(this).data('confirm'), {
        color,
        hideAfterResolve: false,
        onResolve: (button) => {
            button = $(button);

            button.attr('disabled', true);
            button.html(`<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>`);
        }
    });

    if(confirm) {
        $('.cm .btn.btn-outline-secondary').attr('disabled', true);
        $(this).submit();
    }
})

// Move all modals so they works in mobile
modal.each(function() {
    $(this).appendTo($(".modals-container"));
})

export const closeModal = (modal) => {
    modal = $(modal)[0];

    let modalInstance = bootstrap.Modal.getInstance(modal);
    modalInstance.hide();
}

export const openModal = (modal) => {
    modal = $(modal)[0];

    let modalInstance = bootstrap.Modal.getInstance(modal);
    if(!modalInstance) {
        modalInstance = new bootstrap.Modal(modal);
    }

    modalInstance.show();
}

/**
 * Polish plurals
 * @param singularNominativ  e.g. komentarz
 * @param pluralNominativ  e.g. komentarze
 * @param pluralGenitive  e.g. komentarzy
 * @param value
 * @returns {*}
 */
export function polishPlurals(singularNominativ, pluralNominativ, pluralGenitive, value) {
    value = Math.abs(value);
    if (value === 1) {
        return singularNominativ;
    } else if (value % 10 >= 2 && value % 10 <= 4 && (value % 100 < 10 || value % 100 >= 20)) {
        return pluralNominativ;
    } else {
        return pluralGenitive;
    }
}

// Sidebar widoczność dzieci gdy collapsed
$("body li.list__element").hover(function() {
    if($('body').hasClass('sidebar-collapsed')) {
        let a = $(this).find('a.parent');
        if(a.length > 0) {
            let ul = $(this).find('ul.list__children--dropdown');
            if(ul.length > 0) {
                let rect = ul[0].getBoundingClientRect();
                if($(window).innerHeight() < rect.y + rect.height) {
                    ul.css('top', (-1 * rect.height) + $(this).outerHeight())
                } else {
                    ul.css('top', 0)
                }
            }
        }
    }
})

function isTouchDevice() {
    return (('ontouchstart' in window) ||
        (navigator.maxTouchPoints > 0) ||
        (navigator.msMaxTouchPoints > 0));
}

const dragSidebar = () => {
    let drag = false;
    let ul = $("ul.sidebar__list");

    let startY = 0;
    let currentYOffset = 0;

    let canOpenLink = true;
    let timeout;

    let oldY = 0;

    const getPageY = (event) => {
        let touch = undefined;
        if (event.originalEvent.touches) {
            touch = event.originalEvent.touches[0];
        }

        return event.pageY || touch?.pageY;
    }

    if(!isTouchDevice()) {
        ul.on('mousedown touchstart', function (e) {
            e.preventDefault();
            drag = true;

            startY = getPageY(e) + currentYOffset;
            clearTimeout(timeout);
        })

        ul.on('mouseup touchend', function (e) {
            e.preventDefault();
            drag = false;

            timeout = setTimeout(() => {
                canOpenLink = true;
            }, 100)
        })

        $(window).on('mousemove touchmove', function (e) {
            if (drag && $('body').hasClass('sidebar-collapsed')) {
                let y = getPageY(e) - startY;

                if (Math.abs(y) > 2) {
                    canOpenLink = false;
                }

                if (y <= 0 && Math.abs(y) < ul[0].scrollHeight - $(window).outerHeight() + 60) {
                    ul.css('top', y + 'px');
                    currentYOffset = Math.abs(y);
                }

                oldY = getPageY(e);
            }
        })

        ul.find('a').on('click touchend', function(e) {
            e.preventDefault();

            if($(this).hasClass('parent')) {
                if(canOpenLink && isTouchDevice() && $('body').hasClass('sidebar-collapsed')) {
                    $(this).next("ul.list__children--dropdown").show();
                    $(this).closest('li').addClass('hovered')
                }

                return;
            }

            if(canOpenLink) {
                window.location = $(this).attr('href');
            }
        })
    }
}
dragSidebar();

if(isTouchDevice()) {
    $(window).on('touchend', function(e) {
        let target = $(e.target);
        let isClosestLink = target.closest('a').hasClass('parent');

        if(!target.is('a.parent') && !isClosestLink) {
            $("ul.list__children--dropdown").hide();
            $('li.hovered').removeClass('hovered');
        }
    })
}
